// frontend/src/components/handbook/ChapterStatusBadge.js
import React from "react";
import { Wrench, FileEdit } from "lucide-react";

const META = {
  wip: {
    label: "in Arbeit",
    title: "Kapitel ist in Arbeit — Inhalt kann sich noch ändern",
    Icon: Wrench,
    className: "bg-amber-100 text-amber-800 border-amber-300",
  },
  draft: {
    label: "Entwurf",
    title: "Kapitel ist Entwurf / Platzhalter — noch nicht freigegeben",
    Icon: FileEdit,
    className: "bg-gray-200 text-gray-600 border-gray-300",
  },
};

const ChapterStatusBadge = ({ status, compact = false, className = "" }) => {
  if (!status || status === "ready") return null;
  const meta = META[status];
  if (!meta) return null;
  const { Icon } = meta;

  if (compact) {
    return (
      <span
        title={meta.title}
        className={`inline-flex items-center justify-center w-4 h-4 rounded-full border ${meta.className} ${className}`}
      >
        <Icon className="w-2.5 h-2.5" />
      </span>
    );
  }

  return (
    <span
      title={meta.title}
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-semibold uppercase tracking-wide border ${meta.className} ${className}`}
    >
      <Icon className="w-3 h-3" />
      {meta.label}
    </span>
  );
};

export const titleStyleForStatus = (status) => {
  if (status === "draft") return "line-through opacity-60";
  if (status === "wip") return "italic";
  return "";
};

export default ChapterStatusBadge;
